import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ModalDataPolicyContainer } from "./ModalDataPolicyStyled";
import { LangContext } from "../../context/langContext";

import closeOutline from './../../utils/images/close_circle_outline.svg';
import close from './../../utils/images/close_circle.svg';

import { getLegalText } from "../../api/legalApi";

import Spinner from './../../components/Spinner/Spinner';
import { Markup } from 'interweave';


export default function ModalDataPolicy() {

    const navigate = useNavigate();

    const { locale } = useContext(LangContext);

    const [englishText, setEnglishText] = useState('');
    const [spanishText, setSpanishText] = useState('');
    const [englishUpdate, setEnglishUpdate] = useState('');
    const [spanishUpdate, setSpanishUpdate] = useState('');

    const [isLoading, setIsLoading] = useState(true);

    var URLactual = window.location.pathname.split('/');

    useEffect(() => {
        getLegalText().then((response) => {

            const legalText = response.filter((legal) => legal.path === URLactual.slice(-1)[0]);

            legalText.map((legal) => {
                setIsLoading(false);
                if (legal.language === "SPANISH") {
                    setSpanishText(legal.body);
                    setSpanishUpdate(legal.sendeddate);
                } else {
                    setEnglishText(legal.body);
                    setEnglishUpdate(legal.sendeddate);
                }
            })
        })
    }, [URLactual]);

    return (
        <ModalDataPolicyContainer>
            <img src={closeOutline} alt="close" className="closeOutside" onClick={() => navigate(-1)} />
            <div className="policyBody">
                {/* <div className="policyHeader">
                    <h2 className="title"><FormattedMessage id="dataPolicy_title" defaultMessage="Política de Datos" /></h2>
                    <img src={close} alt="close" className="close" onClick={() => navigate(-1)} />
                </div>
                <div className="update">
                    <FormattedMessage id="dataPolicy_text_date" defaultMessage="Última actualización:" />
                    <span> {(locale === 'es-CO') ? spanishUpdate : englishUpdate}</span></div>
                <hr /> */}
                <div className="policyHeader">
                    <img src={close} alt="close" className="close" onClick={() => navigate(-1)} />
                </div>
                {(locale === 'es-CO') ? (<Markup content={spanishText} />) : (<Markup content={englishText} />)}

            </div>

            {(isLoading) && (<Spinner />)}

        </ModalDataPolicyContainer>
    )
}